module.exports = __webpack_public_path__ + "img/aircraftChange.3b9e39ba.svg";